/**
 * @author      jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { checkLoggedIn } from '@zcode-ui/web-zumper-global-state'
import type { Dispatch } from 'redux'
import { selectIsMessaging3Active } from '../../../inspectors/index'
import { selectEntity } from '../../detail/modules/entity/selectors/index'
import { selectProfileIsAutoSharePrequal } from '../../profile/selectors/index'
import { loadProfile } from '../../profile/thunks/loadProfile'
import { selectRenterQuestionKeys } from '../../renterQuestions/selectors/index'
import { loadRenterQuestions } from '../../renterQuestions/thunks/loadRenterQuestions'
import type { GetState } from '../../types'
import { selectProfileShareId } from '../selectors/index'
import { createProfileShare } from './createProfileShare'

export const getProfileShareId = async (dispatch: Dispatch, getState: GetState) => {
  if (!checkLoggedIn(getState()) || !selectIsMessaging3Active(getState())) {
    return
  }

  const entity = selectEntity(getState())
  const { listingId, buildingId } = entity ?? {}

  await dispatch(loadRenterQuestions(listingId, buildingId))

  const keys = selectRenterQuestionKeys(getState())
  if (!keys?.length) {
    return
  }
  await dispatch(loadProfile(keys.concat('AUTO_SHARE_PREQUAL').join(',')))

  if (!selectProfileIsAutoSharePrequal(getState())) {
    return
  }

  await dispatch(createProfileShare(keys, listingId))
  return selectProfileShareId(getState())
}
